import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import rpaTemplateApi from '../api/rpaTemplate'

const api = async (method, path, params) => axios[method](path, params)

const state = {
    template: null,
    query: '',
    templates: [],
    filters: {},
    pagination: null,
    options: {},
    templateItems: [],
}


const getters = {
    ams_integration_codes: state => state.options.ams_integration_codes,
    rpa_integration_codes: state => state.options.rpa_integration_codes,
}

const mutations = {
    set_options(state, payload) {
        state.options = payload
    },
    set_template(state, payload) {
        state.template = payload
    },
    set_templates(state, payload) {
        console.log(payload, "set_templates")
        state.templates = payload
    },
    set_templateItems(state, payload) {
        console.log(payload, "set_templateItems")
        state.templateItems = payload
    },
    set_pagination(state, payload) {
        state.pagination = payload
    },

    SET_FILTERS(state, payload) {
        state.filters = payload
    },

    SET_QUERY(state, payload) {
        state.filters = payload
    },
}

const actions = {
    async create({ commit, state }, payload) {
        try {
            const results = await rpaTemplateApi.create(payload)
            const data = results.data.success.data
            state.templates.push(data);
            commit('set_template', data);
        } catch (err) {
            errorHandler(err)
        }
    },
    async getOptions({ commit, }) {
        try {
            const result = await api('get', `rpa-template/options`)
            const value = JSON.parse(result.data.success.data);
            commit('set_options', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchById({ commit }, id) {
        try {
            const response = await rpaTemplateApi.fetchById(id);
            const template = response.data.success.data;
            commit('set_template', template);
            return template;
        } catch (err) {
            console.error('Error fetching template:', err);
            errorHandler(err);
            throw err;
        }
    },

    async fetchAll(
        { commit },
        { query = '', filters = {}, page = 1 } = {}
    ) {
        try {
            filters = filters || {};
            query = query || "";

            commit("SET_FILTERS", filters);
            commit("SET_QUERY", query);

            const result = await rpaTemplateApi.fetchAll(query, filters, page);
            
            if (!result.data || !result.data.success) {
                throw new Error('Invalid response format');
            }

            const {
                data: templates = [],
                current_page = 1,
                per_page = 15,
                total = 0,
            } = result.data.success.data || {};
            
            commit("set_pagination", {
                page: current_page,
                pageSize: per_page,
                total: total
            });
            commit("set_templates", templates);
            return { templates, pagination: { page: current_page, pageSize: per_page, total } };
        } catch (err) {
            console.error('Error fetching templates:', err);
            errorHandler(err);
            throw err;
        }
    },

    async update({ commit, state }, payload) {
        console.log('update', payload)
        try {
            const results = await rpaTemplateApi.update(payload.id, payload)
            const data = results.data.success.data
            const idx = state.templates.findIndex(x => x.id == data.id)
            state.templates.splice(idx, 1, data)
            commit('set_template', data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete({ commit, state }, id) {
        try {
            await rpaTemplateApi.delete(id)
            const idx = state.templates.findIndex(x => x.id == id)
            state.templates.splice(idx, 1)
            commit('set_template', null)
        } catch (err) {
            errorHandler(err)
        }
    },
    /////////////////////////////////////////
    async createItem({ state }, payload) {
        try {
            const results = await rpaTemplateApi.createItem(state.template.id, payload)
            const data = results.data.success.data
            state.templateItems.push(data);
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchItems({ commit }, templateId) {
        try {
            if (!templateId) {
                throw new Error('Template ID is required');
            }
            const result = await rpaTemplateApi.fetchItems(templateId);
            if (!result.data || !result.data.success) {
                throw new Error('Invalid response format');
            }
            commit("set_templateItems", result.data.success.data || []);
            return result.data.success.data;
        } catch (err) {
            console.error('Error fetching items:', err);
            errorHandler(err);
            throw err;
        }
    },

    async updateItem({ state }, payload) {
        console.log('updateItem:', payload)
        try {
            const results = await rpaTemplateApi.updateItem(state.template.id, payload.id, payload)
            const data = results.data.success.data
            const idx = state.templateItems.findIndex(x => x.id == data.id)
            state.templateItems.splice(idx, 1, data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async deleteItem({ state }, id) {
        try {
            await rpaTemplateApi.deleteItem(state.template.id, id)
            const idx = state.templateItems.findIndex(x => x.id == id)
            state.templateItems.splice(idx, 1)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetchItemById(_, { templateId, itemId }) {
        try {
            if (!templateId || !itemId) {
                throw new Error('Template ID and Item ID are required');
            }
            return await rpaTemplateApi.fetchItemById(templateId, itemId);
        } catch (err) {
            console.error('Error fetching item:', err);
            errorHandler(err);
            throw err;
        }
    },

    async exportExcel(context, { query }) {
        try {
            console.log('Calling exportExcel API with query:', query);
            
            // Call the API
            const response = await rpaTemplateApi.exportExcel(query);
            console.log('API response received:', response);
            
            if (response && response.data && response.data.file_data) {
                const base64Data = response.data.file_data.trim();
                
                // Decode the Base64 string
                const binaryString = window.atob(base64Data);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);
                
                for (let i = 0; i < len; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                
                // Create a blob from the binary data
                const blob = new Blob([bytes.buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                
                // Create a download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", response.data.file_name || "rpa_templates_export.xlsx");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                throw new Error('Export failed: No data received');
            }
            
            return response;
        } catch (err) {
            console.error('Export error:', err);
            errorHandler(err);
            return null;
        }
    },

    async exportExcelAsText(context, { query, filters }) {
        try {
            filters = filters || {};
            query = query || "";
            console.log('Calling exportExcelAsText API with query:', query, 'and filters:', {...filters, include_items: true});
            const response = await rpaTemplateApi.exportExcelAsText(query, {...filters, include_items: true});
            console.log('API text response received:', response);
            return response;
        } catch (err) {
            console.error('Export as text error:', err);
            errorHandler(err);
            return null;
        }
    },

    async exportExcelCSV(context, { query_rpa }) {
        try {
            console.log('Calling exportExcelCSV API with query:', query_rpa);
            const response = await rpaTemplateApi.exportExcelCSV(query_rpa || '');
            console.log('API response received:', response);
            return response;
        } catch (err) {
            console.error('Export CSV error:', err);
            errorHandler(err);
            return null;
        }
    },
    
    async importFile(context, formData) {
        try {
            console.log('Calling import API');
            const response = await rpaTemplateApi.import(formData);
            console.log('Import response received:', response);
            
            // Refresh the templates list after import
            await context.dispatch('fetchAll', {});
            
            return response;
        } catch (err) {
            console.error('Import error:', err);
            errorHandler(err);
            throw err;
        }
    },

    async validateImportFile(context, formData) {
        try {
            return await rpaTemplateApi.validateImportFile(formData);
        } catch (err) {
            errorHandler(err);
            throw err;
        }
    },
    
    async importTemplates({ dispatch }, formData) {
        try {
            const result = await rpaTemplateApi.import(formData);
            // Refresh the templates list after import
            await dispatch('fetchAll', { query: '', filters: {}, page: 1 });
            return result;
        } catch (err) {
            errorHandler(err);
            throw err;
        }
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
